import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import type React from 'react';
import { FormattedMessage } from 'react-intl';

// ── Comparing the result against the structure ───────────────────────
//
// The preview draws the structure as the operation would leave it, in the
// preview colour, in place of the structure it came from. That answers
// "what will this do" but not "is that better than what I have" — for
// which the clinician needs both pictures, and the only way to get them
// is one after the other.
//
// Unchecking hides the held result rather than discarding it, so coming
// back costs nothing and both pictures are of the SAME computation. Apply
// stays available either way: what it commits is the computed result, and
// whether the user is looking at it right now does not change that.

export default function ShowPreviewToggle({
    visible,
    onChange,
    disabled = false,
}: {
    visible: boolean;
    onChange: (visible: boolean) => void;
    /** No result computed yet, so there is nothing to compare against. */
    disabled?: boolean;
}) {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    size="small"
                    checked={visible}
                    disabled={disabled}
                    onChange={(event) => onChange(event.target.checked)}
                    sx={{ py: 0.25 }}
                    // On the input, not the wrapper: a disabled MUI
                    // Checkbox disables the input, and a test that
                    // addressed the span would pass on a live control.
                    inputProps={
                        {
                            'data-testid': 'show-preview-toggle',
                        } as React.InputHTMLAttributes<HTMLInputElement>
                    }
                />
            }
            label={
                <Typography variant="body2" color="text.secondary">
                    <FormattedMessage id="postProcessing.showPreview" />
                </Typography>
            }
            sx={{ ml: 0, mr: 0 }}
        />
    );
}
